<mat-toolbar-row style="margin-bottom: -1.25em;">
  <span class="footer-center">
    Need help? Email <a href="mailto:dersupport@calibrantenergy.com">dersupport&#64;calibrantenergy.com</a>
  </span>
</mat-toolbar-row>
